<template>
    <div>
        <div class="form-group col-12 mb-4">
            Use links without our domains (if it is an internal link)<br />
            {{ frontendUrl }}/articles <b>&#10005;</b> <br />
            /articles
            <b>&#10003;</b>
        </div>

        <div class="form-group col-12">
            <draggable
                :list="menuItems"
                handle=".handle"
                @start="drag = true"
                @end="drag = false"
            >
                <div
                    v-for="(menu, menuIndex) in menuItems"
                    :key="menuIndex"
                    class="card mb-3"
                    :class="{
                        'error-border': v.$each[menuIndex].$error
                    }"
                >
                    <button
                        class="btn col-12 p-2 bg-light text-center align-items-center d-flex"
                        @click="editMenu(menuIndex)"
                    >
                        <button
                            class="handle col-md-1 col-sm-2 col-3 btn btn-info"
                        >
                            <i class="fas fa-arrows-alt" />
                        </button>
                        <button
                            class="col-md-1 col-sm-2 col-3 btn btn-danger waves-effect waves-ligh mx-3"
                            type="button"
                            @click="removeItem(menuIndex)"
                        >
                            <i class="far fa-trash-alt" />
                        </button>
                        #{{ menuIndex + 1 }} | {{ menu.title }}
                    </button>

                    <menu-form
                        v-if="editedIndex === menuIndex"
                        v-model="menuItems[menuIndex]"
                        :v="v.$each[menuIndex]"
                        :menu-index="menuIndex"
                        class="px-3 pt-3"
                    />
                </div>
            </draggable>
            <div class="d-flex justify-content-center">
                <button
                    class="btn btn-success waves-effect waves-light mr-1 mt-4"
                    @click="addItem"
                >
                    <i class="fas fa-plus-circle" /> Add section
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Draggable from 'vuedraggable';
import { frontendUrl } from '@/config';
import MenuForm from '@/components/header/Menu';

export default {
    components: {
        MenuForm,
        Draggable
    },

    props: {
        value: {
            type: Array,
            required: true
        },
        v: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            frontendUrl,
            menuItems: [],
            editedIndex: null
        };
    },

    watch: {
        menuItems() {
            this.$emit('input', this.menuItems);
        }
    },

    created() {
        this.menuItems = [...this.value];
    },

    methods: {
        addItem() {
            this.menuItems.push({
                title: '',
                articles: [],
                subMenus: [],
                links: []
            });

            this.editedIndex = this.menuItems.length - 1;
        },

        removeItem(index) {
            this.menuItems.splice(index, 1);
        },

        editMenu(index) {
            this.editedIndex = this.editedIndex === index ? null : index;
        }
    }
};
</script>
